<div class="flex flex-col space-y-4">
  <form [formGroup]="address">
    <div class="flex space-x-4">
      <mat-form-field class="w-2/5">
        <mat-label>Street</mat-label>
        <input
          matInput
          type="text"
          name="addressStreet"
          placeholder="Street"
          formControlName="street"
          [attr.aria-label]="'street'"
        />
      </mat-form-field>
      <mat-form-field class="w-1/3">
        <mat-label>City</mat-label>
        <input
          matInput
          type="text"
          name="addressCity"
          placeholder="City"
          formControlName="city"
          [attr.aria-label]="'city'"
        />
      </mat-form-field>
      @if (findCountryStates()) {
        <div class="w-1/3" [attr.aria-label]="'states'">
          <phoenix-autocomplete
            (valueChange)="address.get('state')?.setValue($event)"
            title="State"
            [optionList]="findCountryStates() || []"
            attrFilter="display"
            attrToSave="id"
            [control]="getControl('state')"
            [customFilter]="customFilter"
          ></phoenix-autocomplete>
        </div>
      } @else {
        <mat-form-field class="w-1/3">
          <mat-label>State</mat-label>
          <input
            matInput
            type="text"
            name="addressState"
            placeholder="State"
            formControlName="state"
            [attr.aria-label]="'state'"
          />
        </mat-form-field>
      }
    </div>
    <div class="flex space-x-4">
      <mat-form-field class="w-2/5">
        <mat-label>Postal code</mat-label>
        <input
          matInput
          type="text"
          name="addressPostal"
          placeholder="Postal code"
          formControlName="postal_code"
          [attr.aria-label]="'postalCode'"
        />
      </mat-form-field>
      <div class="w-3/5" [attr.aria-label]="'country'">
        <phoenix-autocomplete
          (valueChange)="onCountryChange($event)"
          title="Country"
          [optionList]="countryList"
          attrFilter="display"
          attrToSave="id"
          [control]="getControl('country')"
          [customFilter]="customFilter"
        ></phoenix-autocomplete>
      </div>
    </div>
    @if (showCoordinates) {
      <div formGroupName="coords" class="flex space-x-4">
        <mat-form-field class="w-2/5">
          <mat-label>Latitude</mat-label>
          <input
            matInput
            type="text"
            name="addressLat"
            placeholder="Latitude"
            formControlName="lat"
            [attr.aria-label]="'latitude'"
          />
        </mat-form-field>
        <mat-form-field class="w-2/5">
          <mat-label>Longitude</mat-label>
          <input
            matInput
            type="text"
            name="addressLon"
            placeholder="Longitude"
            formControlName="lon"
            [attr.aria-label]="'longitude'"
          />
        </mat-form-field>
        @if (!address.disabled) {
          <div class="flex flex-row justify-center">
            <phoenix-info-helper
              class="mt-4"
              tooltip=" Use the Raw field or fill in all the address fields and then
          use the button to calculate the coordinates."
            ></phoenix-info-helper>

            <button
              mat-button
              color="primary"
              matButton="filled"
              [disabled]="loadingRequest || !checkAddress"
              type="button"
              class="!h-[45px]"
              (click)="getManualCoordinates()"
            >
              Calculate Coordinates
            </button>
            @if (loadingRequest) {
              <mat-spinner [diameter]="30"></mat-spinner>
            }
          </div>
        }
      </div>
    }
    <div class="flex space-x-4">
      <mat-form-field class="w-full" fxFlex="100">
        <mat-label>Raw</mat-label>
        <textarea
          matInput
          name="addressRaw"
          placeholder="Raw"
          formControlName="raw"
          appAutosize
          matTooltip="Full address, without separating it to parts"
          [attr.aria-label]="'raw'"
        ></textarea>
        <mat-hint class="text-gray-500 italic" align="end">
          <small>
            Sugested format: Street number, street name, City, State, Zip code
            <br />
            <em>E.g.: 6100 Hollywood blvd, Hollywood, FL </em>
          </small>
        </mat-hint>
      </mat-form-field>
    </div>
  </form>
</div>
